import StateFetch from '../fetch/StateFetch';
import AppFetch from '../fetch/AppFetch';

export const getUserPermissibleStateCodes = (productType = 'PC', userInfo) => {
  if (!userInfo) {
    userInfo = AppFetch.fetchUserInfo();
  }

  if (!userInfo) {
    return null;
  }

  const permissibleStates = [];

  if (userInfo && userInfo['products']) {
    userInfo['products'].forEach((product) => {
      if (productType in product) {
        product[productType].split(',').forEach((state) => {
          permissibleStates.push(state);
        });
      }
    });
  }

  var index = permissibleStates.indexOf('US Territories');
  if (index !== -1) {
    permissibleStates[index] = 'Puerto Rico';
    permissibleStates.push('U.S. Virgin Islands');
    permissibleStates.push('Guam');
    permissibleStates.push('American Samoa');
    permissibleStates.push('N. Mariana Islands');
  }

  return StateFetch.fetchStates().filter((state) => {
    return (
      permissibleStates.indexOf('All States') > -1 || permissibleStates.indexOf(state.name) > -1
    );
  });
};
